import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_ALL_EQUIPMENT,
  GET_EQUIPMENT_TYPES,
  GET_EQUIPMENT_BRANDS,
  CREATE_EQUIPMENT,
} from './constants';
import {
  getAllEquipmentSuccess,
  getAllEquipmentError,
  getEquipmentBrandsSuccess,
  getEquipmentBrandsError,
  getEquipmentTypesSuccess,
  getEquipmentTypesError,
  createEquipmentSuccess,
  createEquipmentError,
} from './actions';
import { fetchData } from '../api';

export function* getAllEquipment() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/equipment`;
    const token = window.localStorage.token;
    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };

    let equipment = yield call(fetchData, url, config);
    yield put(getAllEquipmentSuccess(equipment));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getAllEquipmentError(error));
  }
}

export function* createEquipment({ equipment }) {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/equipment`;
    const config = {
      method: 'POST',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(equipment),
    };

    const createdEquipment = yield call(fetchData, url, config);
    yield put(createEquipmentSuccess(createdEquipment));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(createEquipmentError(error));
  }
}

export function* getEquipmentBrands() {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/equipment-brand`;

    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const equipmentBrands = yield call(fetchData, url, config);

    yield put(getEquipmentBrandsSuccess(equipmentBrands));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getEquipmentBrandsError(error));
  }
}

export function* getEquipmentTypes() {
  const token = localStorage.token;
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/equipment-type`;

    const config = {
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json',
      },
    };
    const equipmentTypes = yield call(fetchData, url, config);

    yield put(getEquipmentTypesSuccess(equipmentTypes));
  } catch (err) {
    console.log(err);
    const error = yield err.json();
    console.log(error);
    yield put(getEquipmentTypesError(error));
  }
}

export default function* equipmentSaga() {
  yield takeLatest(CREATE_EQUIPMENT, createEquipment);
  yield takeLatest(GET_ALL_EQUIPMENT, getAllEquipment);
  yield takeLatest(GET_EQUIPMENT_TYPES, getEquipmentTypes);
  yield takeLatest(GET_EQUIPMENT_BRANDS, getEquipmentBrands);
}
